export default function Plans() {
  return (
    <>
      <section id="plans" className="sec">
        <div className="shell">
          <div style={{ maxWidth: '620px' }}>
            <p className="eyebrow">Plans</p>
            <h2 className="h-lg" style={{ marginTop: '18px' }}>Simple Plans.<br />Powerful Platform.</h2>
            <p className="lead" style={{ marginTop: '22px' }}>Two ways to run PlaySlot. Both include the whole platform &mdash; the difference is where your players find you.</p>
          </div>

          {/* desktop comparison */}
          <div className="plans">
            <div className="plans-head">
              <div></div>
              <div>
                <h3>Basic</h3>
                <p>White-label web app for your club.</p>
              </div>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                  <h3 style={{ color: 'var(--lime)' }}>Basic Plus</h3>
                  <span className="mono" style={{ fontSize: '9px', letterSpacing: '.14em', background: 'rgba(200,255,60,.14)', color: 'var(--lime)', padding: '4px 8px', borderRadius: '20px' }}>MOST CLUBS</span>
                </div>
                <p>Web app plus native iOS and Android.</p>
              </div>
            </div>
            <div className="plan-row"><span>Reservations</span><span className="tick">&#10003;</span><span className="tick">&#10003;</span></div>
            <div className="plan-row"><span>Events</span><span className="tick">&#10003;</span><span className="tick">&#10003;</span></div>
            <div className="plan-row"><span>Coach Connect</span><span className="tick">&#10003;</span><span className="tick">&#10003;</span></div>
            <div className="plan-row"><span>Membership</span><span className="tick">&#10003;</span><span className="tick">&#10003;</span></div>
            <div className="plan-row"><span>Admin Panel</span><span className="tick">&#10003;</span><span className="tick">&#10003;</span></div>
            <div className="plan-row"><span>Payments Integration</span><span className="tick">&#10003;</span><span className="tick">&#10003;</span></div>
            <div className="plan-row"><span>Analytics</span><span className="tick">&#10003;</span><span className="tick">&#10003;</span></div>
            <div className="plan-row"><span>iOS / Android App</span><span className="no">&mdash;</span><span className="tick">&#10003;</span></div>
            <div className="plans-foot">
              <div className="disp">Let&rsquo;s build the right plan for your club.</div>
              <a className="btn btn-primary" href="#demo">Request a Demo</a>
            </div>
          </div>

          {/* mobile cards */}
          <div className="plan-cards">
            <div className="plan-card">
              <h3 className="disp" style={{ fontWeight: '800', fontSize: '22px', letterSpacing: '-.02em' }}>Basic</h3>
              <p style={{ fontSize: '14px', color: 'var(--ink-3)', marginTop: '6px' }}>White-label web app for your club.</p>
              <ul>
                <li><span className="tick">&#10003;</span>Reservations, Events, Coach Connect</li>
                <li><span className="tick">&#10003;</span>Membership and Admin Panel</li>
                <li><span className="tick">&#10003;</span>Payments and Analytics</li>
                <li style={{ color: 'var(--ink-4)' }}><span>&mdash;</span>iOS / Android app</li>
              </ul>
            </div>
            <div className="plan-card featured">
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                <h3 className="disp" style={{ fontWeight: '800', fontSize: '22px', letterSpacing: '-.02em', color: 'var(--lime)' }}>Basic Plus</h3>
                <span className="mono" style={{ fontSize: '9px', letterSpacing: '.14em', background: 'rgba(200,255,60,.16)', color: 'var(--lime)', padding: '4px 8px', borderRadius: '20px' }}>MOST CLUBS</span>
              </div>
              <p style={{ fontSize: '14px', color: 'var(--ink-3)', marginTop: '6px' }}>Web app plus native iOS and Android.</p>
              <ul>
                <li><span className="tick">&#10003;</span>Everything in Basic</li>
                <li><span className="tick">&#10003;</span>Branded iOS and Android apps</li>
                <li><span className="tick">&#10003;</span>Push notifications for your players</li>
              </ul>
            </div>
            <p style={{ fontSize: '14.5px', color: 'var(--ink-2)', marginTop: '18px' }}>Let&rsquo;s build the right plan for your club.</p>
            <a className="btn btn-primary btn-block" href="#demo" style={{ marginTop: '14px' }}>Request a Demo</a>
          </div>
        </div>
      </section>
    </>
  );
}
